import {
  REGISTER_REWARD_MAX_AGE_MS,
  REGISTER_REWARD_POINTS_THRESHOLD,
} from '@/constants/register-reward';

export function parseProfileCreateTimeMs(createTime) {
  const raw = String(createTime ?? '').trim();
  if (!raw) return null;
  const ms = new Date(raw).getTime();
  return Number.isFinite(ms) ? ms : null;
}

/** createTime 在注册奖励窗口内（≤ 2 分钟） */
export function isWithinRegisterRewardWindow(createTime, nowMs = Date.now()) {
  const createdMs = parseProfileCreateTimeMs(createTime);
  if (createdMs == null) return false;
  const ageMs = nowMs - createdMs;
  return ageMs >= 0 && ageMs <= REGISTER_REWARD_MAX_AGE_MS;
}

export function readPointsWalletTotal(walletRes) {
  const total = Number(walletRes?.total);
  if (Number.isFinite(total)) return total;
  const available = Number(walletRes?.available);
  return Number.isFinite(available) ? available : null;
}

/** total > 阈值 → 老用户；total <= 阈值 且在 2 分钟内 → 可弹 */
export function isOldUserByPoints(pointsTotal) {
  const total = Number(pointsTotal);
  if (!Number.isFinite(total)) return true;
  return total > REGISTER_REWARD_POINTS_THRESHOLD;
}

export function shouldShowRegisterRewardPopup({ createTime, pointsTotal }) {
  if (!isWithinRegisterRewardWindow(createTime)) return false;
  if (isOldUserByPoints(pointsTotal)) return false;
  return true;
}
